import { defineStore } from 'pinia';
import { reactive } from 'vue';
import { apiClient } from '@/apis';

const dataStore = defineStore('data', () => {
  const kakaoProfiles = reactive({
    init: false,
    list: [],
  });

  const departments = reactive({
    init: false,
    list: [],
  });

  const organizationInfo = reactive({
    init: false,
    name: '',
    company: '',
    serviceName: '',
  });

  const getKakaoProfiles = () => {
    if (kakaoProfiles.init) {
      return kakaoProfiles;
    }

    apiClient.get('/kakao-profile', { params: { page: 0 } })
      .then((response) => {
        kakaoProfiles.list = response.dataList.map?.(({ name, id }) => ({
          label: name,
          value: id,
        })) ?? [];

        kakaoProfiles.init = true;
      })
      .catch((error) => {
        console.error(error);
      });

    return kakaoProfiles;
  };

  const getDepartments = () => {
    if (departments.init) {
      return departments;
    }

    apiClient.get('/departments', { params: { page: 0 } })
      .then((response) => {
        departments.list = response.dataList.map?.(({ id, name }) => ({
          label: name,
          value: id,
        })) ?? [];

        departments.init = true;
      })
      .catch((error) => {
        console.error(error);
      });

    return departments;
  };

  const getOrganizationInfo = () => {
    if (organizationInfo.init) {
      return organizationInfo;
    }

    apiClient.get('/users')
      .then((response) => {
        const {
          name,
          organizationName,
          serviceName,
        } = response;

        organizationInfo.init = true;
        organizationInfo.name = name;
        organizationInfo.company = organizationName;
        organizationInfo.serviceName = serviceName;
      })
      .catch((error) => {
        console.error(error);
      });

    return organizationInfo;
  };

  const setOrganizationInfo = ({
    name,
    company,
    serviceName,
  }) => {
    organizationInfo.init = true;
    organizationInfo.name = name;
    organizationInfo.company = company;
    organizationInfo.serviceName = serviceName;
  };

  const resetOrganizationInfo = () => {
    kakaoProfiles.init = false;
    kakaoProfiles.list = [];
    departments.init = false;
    departments.list = [];
    organizationInfo.init = false;
    organizationInfo.name = '';
    organizationInfo.company = '';
    organizationInfo.serviceName = '';
  };

  return {
    getKakaoProfiles,
    getDepartments,
    getOrganizationInfo,
    setOrganizationInfo,
    resetOrganizationInfo,
  };
});

export default dataStore;
